export const API_METHODS = {
  GET: "get",
  POST: "post",
  PUT: "put",
  DELETE: "delete",
};

export const DEFAULT_DATE_FORMAT = "DD-MM-YYYY";
export const BLANK_VALUE = "__";
export const EMPTY_VALUE = "";

//export const API_URL = "http://localhost:4000/api"; //
export const API_URL = "https://expertedgepublications.com/api";
